import Vue from 'vue'
import { hasAuth } from './index'

Vue.directive('auth', {// 權限指令，根据是否拥有權限判断是否顯示按钮
  bind: function (el, binding) {
    if (el.style.display === 'none') {
      return
    }
    el.style.display = hasAuth(binding.value.toString()) ? '' : 'none'
  }
})
